module.exports = __webpack_public_path__ + "static/consensys-377bb43035a3bd695a0debca63e52859.svg";